import React, { Component } from "react";
// get our fontawesome imports
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class TemplateV1 extends Component {
  constructor() {
    super();
    this.state = {
      msg: null,
      type: null,
      flash: false,
      alert: null,
    };
  }

  render() {
    return (
      <div>
        <div className="container-fluid overflow-hidden px-0">
          <div
            id="carouselExampleCaptions"
            className="carousel slide carousel-fade mx-0"
            data-bs-ride="carousel"
            data-bs-pause="false"
          >
            <div className="carousel-indicators">
              <button
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide-to="0"
                className="active"
                aria-current="true"
                aria-label="Slide 1"
              ></button>
              <button
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide-to="1"
                aria-label="Slide 2"
              ></button>
              <button
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide-to="2"
                aria-label="Slide 3"
              ></button>
            </div>

            <div className="carousel-inner">
              <div className="main-heading">
                <h1 className="main-title display-v2">
                  Save
                  <br />
                  The Date
                  <div className="display-4 the-date">
                    - 2<span className="text-pink">.</span>Juni
                    <span className="text-pink">.</span>2021 -
                  </div>
                </h1>
                <div className="col-12 col-sm-5 mx-auto">
                  <hr />
                  <p className="fs-4">We Are Getting Married</p>
                  <hr />
                </div>
              </div>
              <div
                className="carousel-item active"
                style={{
                  backgroundImage: `url(https://cdn.pixabay.com/photo/2014/09/13/04/59/couple-443600_960_720.jpg)`,
                }}
              >
                <div className="carousel-caption overlay-color"></div>
              </div>
              <div
                className="carousel-item"
                style={{
                  backgroundImage: `url(https://cdn.pixabay.com/photo/2020/01/20/12/44/wedding-4780256_960_720.jpg)`,
                }}
              >
                <div className="carousel-caption overlay-color"></div>
              </div>
              <div
                className="carousel-item"
                style={{
                  backgroundImage: `url(https://cdn.pixabay.com/photo/2016/11/22/19/05/couple-1850073_960_720.jpg)`,
                }}
              >
                <div className="carousel-caption overlay-color"></div>
              </div>
            </div>
            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div className="container-fluid overflow-hidden bg-light px-0">
          <div className="container wrapper">
            <div className="row text-center">
              <h1 className="sec-title fw-bold">THE HAPPY COUPLE</h1>
              <p className="py-3 fs-5 text-secondary">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
                ultrices malesuada ante quis pharetra. Nullam non bibendum
                dolor. Ut vel turpis accumsan, efficitur dolor fermentum,
                tincidunt metus.
              </p>
            </div>
            <div className="row">
              <div className="text-center">
                <div className="grey-line me-2"> </div>
                <FontAwesomeIcon icon={faHeart} className="fs-4 pink-heart" />
                <FontAwesomeIcon icon={faHeart} className="fs-4 grey-heart" />
                <div className="grey-line ms-2"> </div>
              </div>
            </div>

            <div className="row row-cols-1 row-cols-md-2 g-4 mt-5">
              <div className="col">
                <div className="card bg-transparent border-0">
                  <div
                    className="person-pict w-100 rounded-4 overflow-hidden"
                    style={{
                      backgroundImage: `url(https://cdn.pixabay.com/photo/2018/11/08/23/52/man-3803551_960_720.jpg)`,
                    }}
                  >
                    <div className="overlay-card"></div>
                  </div>
                  <div className="card-body px-0">
                    <h5 className="card-title fs-4 fw-bold">Fulan bin Fulan</h5>
                    <p className="card-text text-desc text-secondary">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Integer ultrices malesuada ante quis pharetra. Nullam non
                      bibendum dolor. Ut vel turpis accumsan, efficitur dolor
                      fermentum, tincidunt metus. Etiam ut ultrices nibh. Etiam
                      aliquam mauris non hendrerit faucibus. Proin pulvinar.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card bg-transparent border-0">
                  <div
                    className="person-pict w-100 rounded-4 overflow-hidden"
                    style={{
                      backgroundImage: `url(https://cdn.pixabay.com/photo/2018/01/15/07/51/woman-3083379_960_720.jpg)`,
                    }}
                  >
                    <div className="overlay-card"></div>
                  </div>
                  <div className="card-body px-0">
                    <h5 className="card-title fs-4 fw-bold">
                      Fulanah binti Fulan
                    </h5>
                    <p className="card-text text-desc text-secondary">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      Integer ultrices malesuada ante quis pharetra. Nullam non
                      bibendum dolor. Ut vel turpis accumsan, efficitur dolor
                      fermentum, tincidunt metus. Etiam ut ultrices nibh. Etiam
                      aliquam mauris non hendrerit faucibus. Proin pulvinar.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid overflow-hidden bg-light px-0">
          <div
            className="semifull-screen"
            style={{
              backgroundImage: `url(https://cdn.pixabay.com/photo/2016/03/27/20/54/wedding-reception-1284245_960_720.jpg)`,
            }}
          >
            <div className="overlay-card">
              <div className="v-h-centered text-center">
                <h1 className="main-title display-v2">
                  Counting
                  <br />
                  Down
                </h1>
                <div className="row mt-3">
                  <div className="text-center">
                    <div className="grey-line me-2"> </div>
                    <FontAwesomeIcon
                      icon={faHeart}
                      className="fs-4 pink-heart"
                    />
                    <FontAwesomeIcon
                      icon={faHeart}
                      className="fs-4 white-heart"
                    />
                    <div className="grey-line ms-2"> </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="count-down fs-4">
                    <span>5 D</span>
                    <span>3 H</span>
                    <span>2 M</span>
                    <span>45 S</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid overflow-hidden bg-light px-0">
          <div className="container wrapper">
            <div className="row text-center">
              <h1 className="sec-title fw-bold">THE WEDDING</h1>
              <p className="py-3 fs-5 text-secondary">
                Lorem ipsum dolor sit amet, consectetur adipiscing lorem ipsum
                dolor sit amet, consectetur adipiscing
              </p>
            </div>
            <div className="row">
              <div className="text-center">
                <div className="grey-line me-2"> </div>
                <FontAwesomeIcon icon={faHeart} className="fs-4 pink-heart" />
                <FontAwesomeIcon icon={faHeart} className="fs-4 grey-heart" />
                <div className="grey-line ms-2"> </div>
              </div>
            </div>
            <div className="row row-cols-1 row-cols-md-3 g-4 mt-5">
              <div className="col">
                <div className="card h-100 border-0 rounded-4">
                  <div
                    className="wedding-pict w-100 rounded-4 overflow-hidden"
                    style={{
                      backgroundImage: `url(https://cdn.pixabay.com/photo/2016/02/19/09/59/taj-mahal-1209004_960_720.jpg)`,
                    }}
                  ></div>
                  <div className="card-body">
                    <h5 className="card-title">Lokasi</h5>
                    <p className="card-text">
                      This is a longer card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card h-100 border-0 rounded-4">
                  <div
                    className="wedding-pict w-100 rounded-4 overflow-hidden"
                    style={{
                      backgroundImage: `url(https://cdn.pixabay.com/photo/2017/08/06/20/11/wedding-2595862_960_720.jpg)`,
                    }}
                  ></div>
                  <div className="card-body">
                    <h5 className="card-title">Akad Nikah</h5>
                    <p className="card-text">
                      This is a longer card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="card h-100 border-0 rounded-4">
                  <div
                    className="wedding-pict w-100 rounded-4 overflow-hidden"
                    style={{
                      backgroundImage: `url(https://cdn.pixabay.com/photo/2016/11/18/18/32/wedding-1836315_960_720.jpg)`,
                    }}
                  ></div>
                  <div className="card-body">
                    <h5 className="card-title">Resepsi Pernikahan</h5>
                    <p className="card-text">
                      This is a longer card with supporting text below as a
                      natural lead-in to additional content.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid overflow-hidden bg-white px-0">
          <div className="container wrapper">
            <div className="row">
              <div className="text-center">
                <div className="grey-line me-2"> </div>
                <FontAwesomeIcon icon={faHeart} className="fs-4 pink-heart" />
                <FontAwesomeIcon icon={faHeart} className="fs-4 grey-heart" />
                <div className="grey-line ms-2"> </div>
              </div>
            </div>
            <div className="row mt-4">
              <h1 className="sec-title fw-bold text-center">
                ARE YOU ATTENDING?
              </h1>
              <p className="py-3 fs-5 text-secondary">
                Lorem ipsum dolor sit amet, consectetur adipiscing lorem ipsum
                dolor sit amet, consectetur adipiscing
              </p>
              <div className="d-grid">
                <button
                  type="button"
                  className="btn btn-outline-pink px-4 mx-auto"
                >
                  Hubungi Kami
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid overflow-hidden bg-light px-0">
          <div
            className="semifull-screen"
            style={{
              backgroundImage: `url(https://cdn.pixabay.com/photo/2016/03/27/20/54/wedding-reception-1284245_960_720.jpg)`,
            }}
          >
            <div className="overlay-card">
              <div className="v-h-centered text-center">
                <h1 className="main-title display-v2">
                  Thank
                  <br />
                  You
                </h1>
                <div className="row mt-5">
                  <div className="text-center">
                    <div className="grey-line me-2"> </div>
                    <FontAwesomeIcon
                      icon={faHeart}
                      className="fs-4 pink-heart"
                    />
                    <FontAwesomeIcon
                      icon={faHeart}
                      className="fs-4 white-heart"
                    />
                    <div className="grey-line ms-2"> </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="count-down fs-4">
                    <span>FULAN & FULANAH</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TemplateV1;
